import { DatePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  OnInit,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { DocumentsType, ProgramTypes } from '../../../models/_enum-collections';
import { AdditionalDocHyperLink } from '../../../models/additional-doc-hyper-link.model';
import { Constants } from '../../../models/constants.model';
import { CustomerAcknowledgement } from '../../../models/customer-ack.model';
import {
  DocumentReviewModel,
  DocumentDetailsModel
} from '../../../models/document-review.model';
import { DocumentTypesString } from '../../../models/document-types.model';
import { EngagementDetails } from '../../../models/engagement-details.model';
import { EngagementPreviewInput } from '../../../models/engagement-preview-input.model';
import {
  FileContentModel,
  PreviewFileTypes
} from '../../../models/file-content.model';
import { InvoiceRejectReason } from '../../../models/invoice-reject-reason';
import { PoeDocHyperLink } from '../../../models/poe-doc-hyper-link.model';
import { PoeInformationSurvey } from '../../../models/poe-information-survey.model';
import {
  PreviewDocumentTypes,
  UpdateCustomerAckDocument
} from '../../../models/update-customer-ack-document.model';
import { CommonSharedModule } from '../../common/shared.module';
import { DashboardService } from '../../services/dashboard.service';
import { OsmosisEditService } from '../../services/osmosis-edit.service';
import { PreviewFileComponent } from '../preview-file/preview-file.component';

@Component({
  selector: 'app-engagement-preview',
  templateUrl: './engagement-preview.component.html',
  styleUrls: ['./engagement-preview.component.scss'],
  standalone: true,
  providers: [PreviewFileComponent],
  imports: [CommonSharedModule, PreviewFileComponent]
})
export class EngagementPreviewComponent implements OnInit {
  @Input() engagementPreviewInput!: EngagementPreviewInput;
  @Output() closePreviewModal = new EventEmitter();
  programTypeId!: number;
  fileContentModel: FileContentModel = {
    fileUrl: '',
    previewFileType: PreviewFileTypes.pdf,
    fileFound: false
  };
  isDocumentPreviewLoading = false;
  isCustomerDocumentPreview = false;
  canShowPreviewModel!: boolean;
  engagementDetails: EngagementDetails;
  isCustomerAckApproval = false;
  customerAck!: CustomerAcknowledgement[];
  downloadSpin = true;
  index = 0;
  isEngDtl = false;
  isCustomerAck = false;
  engagementIdList!: number[];
  engagementIndex!: number;
  showApproveDeny!: boolean;
  msgsUsageDetails!: any[];
  addPoeInformationSurvey!: PoeInformationSurvey;
  modalTitle!: string;
  invoiceRejectionList!: InvoiceRejectReason[];
  invoiceRejectionModalDisplay!: boolean;
  @Output() OnCustomerAckReview: EventEmitter<any> = new EventEmitter<any>();
  @Output() reLoadList: EventEmitter<any> = new EventEmitter<any>();
  @Output() OnInvoiceReview: EventEmitter<any> = new EventEmitter<any>();
  @Output() OnPoeDocumentReview: EventEmitter<any> = new EventEmitter<any>();
  @Output() OnDocumentTypeChange: EventEmitter<any> = new EventEmitter<any>();
  datePipe = new DatePipe('en-US');
  formInvoiceRejection!: FormGroup;
  invoiceDocument = 'Workshop Invoice POE Template';
  invoiceSpecialInvestmentDocument = 'Invoice POE Special Investments';
  rfpDescriptionDocument = 'Request For Proposal Description';
  rfpAwardDocument = 'Request For Proposal Award Letter';
  SOWDocument = 'Statement of Work';
  poeDocHyperLinks!: PoeDocHyperLink[];
  documentUploadedDate!: Date;
  documentStatus!: string;
  surveyDate!: string;
  surveyStatus!: string;
  poeDetailsForm!: FormGroup;
  showTypeChangeButtons!: boolean;
  poeDocumentType = Constants.poeDocumentType;
  selectedWorkshopCompletionDate!: Date;
  disableApproval = false;
  isApproveReject = false;
  isSurveyPreview = false;
  @ViewChild(PreviewFileComponent) previewFileComponent!: PreviewFileComponent;

  constructor(
    private sanitizer: DomSanitizer,
    private previewfile: PreviewFileComponent,
    private osmEdit: OsmosisEditService,
    private dashboardService: DashboardService,
    private formBuilder: FormBuilder
  ) {
    this.engagementDetails = {} as EngagementDetails;
  }
  OnFormGroup() {
    this.formInvoiceRejection = this.formBuilder.group({
      invoiceRejectionReason: [''],
      additionalNotesRejectionReason: ['']
    });

    this.poeDetailsForm = this.formBuilder.group({
      poeDocumentTypeName: ['']
    });
  }
  ngOnInit() {
    this.canShowPreviewModel = true;
    this.showTypeChangeButtons = false;
    if (
      this.engagementPreviewInput.isCustomerAckApproval ||
      this.engagementPreviewInput.isPoePreview ||
      this.engagementPreviewInput.documentType ===
        PreviewDocumentTypes.customerSurvey
    ) {
      this.engagementIdList =
        this.engagementPreviewInput.engagementIdList || [];

      this.engagementIndex = this.engagementIdList.indexOf(
        this.engagementPreviewInput.engagementId
      );
    }

    this.showPreview(this.engagementPreviewInput.engagementId);
    this.OnFormGroup();
  }

  get isRFPDescriptionPreview() {
    return (
      this.engagementPreviewInput.documentType ===
      PreviewDocumentTypes.rfpDescription
    );
  }

  get isRFPAwardPreview() {
    return (
      this.engagementPreviewInput.documentType === PreviewDocumentTypes.rfpAward
    );
  }

  get isPoeInvoicePreview() {
    return (
      this.engagementPreviewInput.documentType ===
      PreviewDocumentTypes.poeinvoice
    );
  }

  get isPoeDocumentPreview() {
    return (
      this.engagementPreviewInput.documentType ===
      PreviewDocumentTypes.poedocument
    );
  }
  get isSOWDocumentPreview() {
    return (
      this.engagementPreviewInput.documentType === PreviewDocumentTypes.SOW
    );
  }

  get isCustomerSurvey() {
    return (
      this.engagementPreviewInput.documentType ===
      PreviewDocumentTypes.customerSurvey
    );
  }
  get isPartnerSurvey() {
    return (
      this.engagementPreviewInput.documentType ===
      PreviewDocumentTypes.partnerSurvey
    );
  }

  get isAdditionalDocPreview() {
    return (
      this.engagementPreviewInput.documentType ===
      PreviewDocumentTypes.additionalDocument
    );
  }

  get isHistoryDocument() {
    return this.engagementPreviewInput.isHistoryDocument;
  }

  get hasWorkshopCompletionDateChanged(): boolean {
    return (
      this.selectedWorkshopCompletionDate !=
      this.engagementDetails.workshopCompletionDate
    );
  }

  showPreview(engagementId) {
    this.canShowPreviewModel = true;
    this.index =
      this.engagementPreviewInput.engagementId === engagementId
        ? this.engagementPreviewInput.previewFileIndex
        : 0;
    this.showApproveDeny = true;
    this.disableApproval = false;

    this.engagementDetails = {
      ...this.engagementDetails,
      engagementId: engagementId
    } as EngagementDetails;
    this.isDocumentPreviewLoading = true;
    this.isCustomerAckApproval =
      this.engagementPreviewInput.isCustomerAckApproval;
    this.getEngagementDetails(engagementId);
    this.isApproveReject = false;
  }

  getEngagementDetails(engagementId): void {
    this.osmEdit
      .getFactDataByRequestDetailsById(engagementId)
      .subscribe(result => {
        if (result.workshopCompletionDate) {
          this.selectedWorkshopCompletionDate = new Date(
            result.workshopCompletionDate
          );
        }
        this.engagementDetails = {
          requestDetailId: engagementId,
          engagementName: result.deliveryName,
          partnerName: result.pmoconfirmedPartnerName,
          enagementPMOTenantName: result.pmoConfirmedTenantName,
          enagementStatus: result.engagementStatus,
          day30ExpirationDate: result.day30ExpirationDate
            ? this.datePipe.transform(
                result.day30ExpirationDate,
                'MM/dd/yyyy'
              ) || undefined
            : undefined,
          submittedDate: result.submittedDate,
          committedDate: result.committedDate
            ? this.datePipe.transform(result.committedDate, 'MM/dd/yyyy') ||
              undefined
            : undefined,
          partnerOrgName: result.partnerOrgName,
          partnerInputDomainName: result.partnerInputDomainName,
          customerOrgName: result.customerOrgName,
          customerDomainName: result.customerDomainName,
          partnerInputRequestorEmail: result.partnerInputRequestorEmail,
          qualifiedAmount: result.qualifiedAmount,
          day90ExpirationDate: result.day90ExpirationDate
            ? this.datePipe.transform(
                result.day90ExpirationDate,
                'MM/dd/yyyy'
              ) || undefined
            : undefined,
          customerSurveyId: result.customerSurveyId,
          partnerSurveyId: result.partnerSurveyId,
          engagementType: result.engagementName || '',
          incentiveAmount: result.incentiveAmount,
          workshopCompletionDate: this.selectedWorkshopCompletionDate,
          milestoneTwoPaymentDesignation: result.milestoneTwoPaymentDesignation
        };
        this.programTypeId = result.programTypeId || -1;
        this.surveyStatus = result.customerPOESurveyStatus || '';
        this.surveyDate =
          this.datePipe.transform(result.customerPOESurveyDate, 'MM/dd/yyyy') ||
          '';
        if (
          this.isPoeDocumentPreview ||
          this.isSOWDocumentPreview ||
          this.isPoeInvoicePreview ||
          this.isRFPDescriptionPreview ||
          this.isRFPAwardPreview
        ) {
          this.getUploadedPOEDocs_ByEngagementId(engagementId);
        } else if (this.isCustomerSurvey) {
          this.getCustomerSurveyResponse(engagementId);
        } else if (this.isPartnerSurvey) {
          this.getPartnerSurveyResponse(engagementId);
        } else if (this.isAdditionalDocPreview) {
          this.resetButton();
          this.previewAdditionalDoc(
            this.engagementPreviewInput.additionalDoc as AdditionalDocHyperLink,
            this.engagementPreviewInput.engagementId
          );
        } else if (this.isHistoryDocument) {
          this.documentUploadedDate =
            this.engagementPreviewInput.invoiceFile?.uploadDate || new Date();
          this.documentStatus =
            this.engagementPreviewInput.invoiceFile?.status || '';
          this.resetButton();
          this.previewInvoice(
            this.engagementPreviewInput.invoiceFile as PoeDocHyperLink,
            engagementId
          );
        } else {
          this.osmEdit
            .getCustomerAcknowledgementFile(engagementId)
            .subscribe(imglist => {
              this.customerAck = imglist;
              this.downloadSpin = imglist.length > 0 ? true : false;
              if (this.downloadSpin) {
                this.previewFile(engagementId);
                this.documentUploadedDate =
                  this.customerAck[this.index].createdOn || new Date();
              }
            });
        }
      });
  }

  previewFile(engagementId) {
    this.fileContentModel = new FileContentModel();
    let fileContentUrl: string;

    const downloadAcknowledgementInputModel: UpdateCustomerAckDocument = {
      engagementId: engagementId,
      fileName: this.customerAck[this.index].fileName,
      documentType: PreviewDocumentTypes.customerAcknowledgement
    };

    this.dashboardService
      .getPreviewFileContent(downloadAcknowledgementInputModel)
      .subscribe(
        downloadFile => {
          if (this.customerAck[this.index].fileName?.endsWith('.pdf')) {
            const file = new Blob([downloadFile], { type: 'application/pdf' });
            fileContentUrl = URL.createObjectURL(file);
            this.fileContentModel.previewFileType = PreviewFileTypes.pdf;
          } else {
            this.fileContentModel.previewFileType = PreviewFileTypes.image;
            const blob = new Blob([downloadFile]);
            const objectURL = URL.createObjectURL(blob);
            fileContentUrl = this.transformURL(objectURL);
          }

          if (fileContentUrl != null) {
            this.fileContentModel.fileFound = true;
            this.fileContentModel.fileUrl = fileContentUrl;
            this.isDocumentPreviewLoading = false;
            this.previewfile.open();
          }
        },
        () => {
          this.isDocumentPreviewLoading = false;
        }
      );
    this.isCustomerDocumentPreview = true;
  }

  transformURL(url: string): any {
    if (!url) {
      return null;
    }
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  previewAdditionalDoc(
    additionalDocFile: AdditionalDocHyperLink,
    engagementId: number
  ) {
    const downloadAcknowledgementInputModel = {
      engagementId: engagementId,
      fileName: additionalDocFile.fileName,
      documentType: PreviewDocumentTypes.additionalDocument
    };

    if (this.isAdditionalDocPreview) {
      downloadAcknowledgementInputModel.fileName =
        additionalDocFile.addnlDocName;
    }

    downloadAcknowledgementInputModel.documentType =
      PreviewDocumentTypes.additionalDocument;

    this.documentUploadedDate =
      this.engagementPreviewInput.additionalDoc?.uploadDate || new Date();

    this.getFileDetails(
      downloadAcknowledgementInputModel,
      additionalDocFile.addnlDocFilePath || ''
    );
  }
  getFileDetails(
    downloadAcknowledgementInputModel: UpdateCustomerAckDocument,
    fileContentUrl: string
  ) {
    this.fileContentModel = new FileContentModel();
    this.fileContentModel.fileFound = true;

    const extension = downloadAcknowledgementInputModel.fileName
      ?.split('.')
      ?.pop();
    if (
      (extension && extension.toLowerCase() === 'doc') ||
      (extension && extension.toLowerCase() === 'docx') ||
      (extension && extension.toLowerCase() === 'ppt') ||
      (extension && extension.toLowerCase() === 'pptx')
    ) {
      switch (extension) {
        case 'docx':
        case 'doc': {
          this.fileContentModel.previewFileType = PreviewFileTypes.doc;
          break;
        }
        case 'pptx':
        case 'ppt': {
          this.fileContentModel.previewFileType = PreviewFileTypes.ppt;
          break;
        }
      }
      if (fileContentUrl != null) {
        this.fileContentModel.fileFound = true;
        this.fileContentModel.fileUrl = fileContentUrl;
        this.isDocumentPreviewLoading = false;
        this.previewfile.open();
      }
    } else if (extension && extension.toLowerCase() === 'pdf') {
      this.dashboardService
        .getPreviewFileContent(downloadAcknowledgementInputModel)
        .subscribe(downloadFile => {
          const file = new Blob([downloadFile], { type: 'application/pdf' });
          fileContentUrl = URL.createObjectURL(file);
          this.fileContentModel.previewFileType = PreviewFileTypes.pdf;
          if (fileContentUrl != null) {
            this.fileContentModel.fileFound = true;
            this.fileContentModel.fileUrl = fileContentUrl;
            this.isDocumentPreviewLoading = false;
            this.previewfile.open();
          }
        });
    } else if (
      (extension && extension.toLowerCase() === 'jpeg') ||
      (extension && extension.toLowerCase() === 'png') ||
      (extension && extension.toLowerCase() === 'jpg') ||
      (extension && extension.toLowerCase() === 'bmp') ||
      (extension && extension.toLowerCase() === 'gif')
    ) {
      this.fileContentModel.previewFileType = PreviewFileTypes.image;
      if (fileContentUrl != null) {
        this.fileContentModel.fileFound = true;
        this.fileContentModel.fileUrl = fileContentUrl;
        this.isDocumentPreviewLoading = false;
        this.previewfile.open();
      }
    } else {
      this.fileContentModel.previewFileType = PreviewFileTypes.unsupported;
      this.fileContentModel.fileFound = true;
      this.fileContentModel.fileUrl = fileContentUrl;
      this.isDocumentPreviewLoading = false;
      this.previewfile.open();
    }
  }

  previewInvoice(invoiceFile: PoeDocHyperLink, engagementId: number) {
    const downloadAcknowledgementInputModel: UpdateCustomerAckDocument = {
      engagementId: engagementId,
      fileName: invoiceFile.fileName,
      documentType: PreviewDocumentTypes.poedocument
    };

    this.getFileDetails(
      downloadAcknowledgementInputModel,
      invoiceFile.poeDocFilePath || ''
    );
  }

  closePreview() {
    this.previewfile.close();
    this.canShowPreviewModel = false;
    this.isCustomerDocumentPreview = false;
    this.reLoadList.emit(true);
    this.closePreviewModal.emit('false');
  }

  closeDeclineModal() {
    this.invoiceRejectionModalDisplay = false;
    this.formInvoiceRejection.reset();
  }

  checkForPrevious() {
    return !(this.engagementIndex == 0);
  }
  checkForNext() {
    return !(this.engagementIndex == this.engagementIdList.length - 1);
  }

  onPreviousClick() {
    this.previewfile.close();
    this.canShowPreviewModel = false;
    this.isCustomerDocumentPreview = false;
    const engagementId = this.engagementIdList[--this.engagementIndex];
    this.showPreview(engagementId);
  }

  onNextClick() {
    this.previewfile.close();
    this.canShowPreviewModel = false;
    this.isCustomerDocumentPreview = false;
    const engagementId = this.engagementIdList[++this.engagementIndex];
    this.showPreview(engagementId);
  }

  submitForApproval() {
    this.disableApproval = true;
    const documentReviewInfo = {
      requestDetailId: this.engagementDetails.requestDetailId || -1,
      isApprove: true,
      documentType: DocumentsType.AdditionalDocument,
      reasons: [],
      additionalNotes: '',
      customerSurveyId: 0,
      filePath: ''
    };

    this.isApproveReject = true;

    if (
      this.engagementPreviewInput.documentType ===
      PreviewDocumentTypes.poedocument
    ) {
      documentReviewInfo.documentType = 3;
      this.reviewPoeDocuments(documentReviewInfo);
    } else if (
      this.engagementPreviewInput.documentType ===
      PreviewDocumentTypes.poeinvoice
    ) {
      documentReviewInfo.documentType = 1;
      this.reviewPoeDocuments(documentReviewInfo);
    } else if (
      this.engagementPreviewInput.documentType ===
      PreviewDocumentTypes.rfpDescription
    ) {
      documentReviewInfo.documentType = 10;
      this.reviewPoeDocuments(documentReviewInfo);
    } else if (
      this.engagementPreviewInput.documentType === PreviewDocumentTypes.rfpAward
    ) {
      documentReviewInfo.documentType = 9;
      this.reviewPoeDocuments(documentReviewInfo);
    } else if (
      this.engagementPreviewInput.documentType ===
      PreviewDocumentTypes.customerSurvey
    ) {
      this.reviewPoeSurvey(documentReviewInfo);
    } else if (
      this.engagementPreviewInput.documentType === PreviewDocumentTypes.SOW
    ) {
      documentReviewInfo.documentType = 13;
      this.reviewPoeDocuments(documentReviewInfo);
    } else {
      this.reviewCustomerAck(documentReviewInfo);
    }
  }

  reviewPoeSurvey(documentReviewInfo: DocumentReviewModel) {
    this.osmEdit.updatePOESurveyReviewStatus(documentReviewInfo).subscribe(
      messageResponse => {
        if (messageResponse.success === true) {
          this.showApproveDeny = false;
          this.isApproveReject = false;
          if (documentReviewInfo.isApprove) {
            if (
              this.engagementPreviewInput.documentType ===
              PreviewDocumentTypes.customerSurvey
            ) {
              this.showMessage('Customer Survey approved.');
            }
          } else {
            this.showMessage('Customer Survey rejected.');
          }
        } else {
          this.showMessage('Sorry an error occured');
          this.isApproveReject = false;
        }
      },
      error => {
        this.showMessage(error.error.errorInfo, true);
        this.isApproveReject = false;
      }
    );
  }

  reviewPoeDocuments(documentReviewInfo: DocumentReviewModel) {
    if (this.programTypeId === ProgramTypes.Accelerator) {
      this.osmEdit.updatePOEDocumentReviewStatus(documentReviewInfo).subscribe(
        messageResponse => {
          if (messageResponse.success === true) {
            this.showApproveDeny = false;
            this.isApproveReject = false;
            if (documentReviewInfo.isApprove) {
              this.documentStatus = 'Approved';
              if (
                this.engagementPreviewInput.documentType ===
                PreviewDocumentTypes.poedocument
              ) {
                this.showMessage('POE Document approved.');
              } else if (
                this.engagementPreviewInput.documentType ===
                PreviewDocumentTypes.poeinvoice
              ) {
                this.showMessage('POE Invoice approved.');
              }
            } else {
              this.documentStatus = 'Rejected';
              if (
                this.engagementPreviewInput.documentType ===
                PreviewDocumentTypes.poedocument
              ) {
                this.showMessage('POE Document rejected.');
              } else if (
                this.engagementPreviewInput.documentType ===
                PreviewDocumentTypes.poeinvoice
              ) {
                this.showMessage('POE Invoice rejected.');
              }
            }
            if (!this.engagementPreviewInput.isPoePreview) {
              if (
                this.engagementPreviewInput.documentType ===
                PreviewDocumentTypes.poedocument
              ) {
                if (
                  !this.engagementPreviewInput.isCustomerAckApproval &&
                  documentReviewInfo.isApprove
                ) {
                  this.OnPoeDocumentReview.emit(true);
                } else if (
                  !this.engagementPreviewInput.isCustomerAckApproval &&
                  !documentReviewInfo.isApprove
                ) {
                  this.OnPoeDocumentReview.emit(false);
                }
              } else {
                if (
                  !this.engagementPreviewInput.isCustomerAckApproval &&
                  documentReviewInfo.isApprove
                ) {
                  this.OnInvoiceReview.emit(true);
                } else if (
                  !this.engagementPreviewInput.isCustomerAckApproval &&
                  !documentReviewInfo.isApprove
                ) {
                  this.OnInvoiceReview.emit(false);
                }
              }
            }
          } else {
            this.showMessage('Sorry an error occured');
            this.isApproveReject = false;
          }
        },
        error => {
          this.showMessage(error.error.errorInfo, true);
          this.isApproveReject = false;
        }
      );
    } else {
      this.osmEdit
        .updatePOEDocumentReviewStatusV2(
          documentReviewInfo,
          this.engagementPreviewInput.documentTypeId
        )
        .subscribe(
          messageResponse => {
            if (messageResponse.success === true) {
              this.showApproveDeny = false;
              this.isApproveReject = false;
              if (documentReviewInfo.isApprove) {
                this.documentStatus = 'Approved';
                this.showMessage(
                  `${DocumentTypesString[this.engagementPreviewInput.documentTypeId]} approved!`
                );
              } else {
                this.documentStatus = 'Rejected';
                this.showMessage(
                  `${DocumentTypesString[this.engagementPreviewInput.documentTypeId]} rejected!`
                );
              }
              if (!this.engagementPreviewInput.isPoePreview) {
                if (
                  this.engagementPreviewInput.documentType ===
                  PreviewDocumentTypes.poedocument
                ) {
                  if (
                    !this.engagementPreviewInput.isCustomerAckApproval &&
                    documentReviewInfo.isApprove
                  ) {
                    this.OnPoeDocumentReview.emit(true);
                  } else if (
                    !this.engagementPreviewInput.isCustomerAckApproval &&
                    !documentReviewInfo.isApprove
                  ) {
                    this.OnPoeDocumentReview.emit(false);
                  }
                } else {
                  if (
                    !this.engagementPreviewInput.isCustomerAckApproval &&
                    documentReviewInfo.isApprove
                  ) {
                    this.OnInvoiceReview.emit(true);
                  } else if (
                    !this.engagementPreviewInput.isCustomerAckApproval &&
                    !documentReviewInfo.isApprove
                  ) {
                    this.OnInvoiceReview.emit(false);
                  }
                }
              }
            } else {
              this.showMessage('Sorry an error occured');
              this.isApproveReject = false;
            }
          },
          error => {
            this.showMessage(error.error.errorInfo, true);
            this.isApproveReject = false;
          }
        );
    }
  }

  reviewCustomerAck(documentReviewInfo: DocumentReviewModel) {
    this.osmEdit
      .updateCustomerAcknowledgementReviewStatus(documentReviewInfo)
      .subscribe(
        messageResponse => {
          if (messageResponse) {
            if (messageResponse.success === true) {
              this.showApproveDeny = false;
              this.isApproveReject = false;
              if (documentReviewInfo.isApprove) {
                this.showMessage('Customer Acknowledgement approved.');
              } else {
                this.showMessage('Customer Acknowledgement rejected.');
              }
              if (
                !this.engagementPreviewInput.isCustomerAckApproval &&
                documentReviewInfo.isApprove
              ) {
                this.OnCustomerAckReview.emit(true);
              } else if (
                !this.engagementPreviewInput.isCustomerAckApproval &&
                !documentReviewInfo.isApprove
              ) {
                this.OnCustomerAckReview.emit(false);
              }
            } else {
              this.showMessage('Sorry an error occured');
              this.isApproveReject = false;
            }
          }
        },
        () => {
          this.isApproveReject = false;
        }
      );
  }

  onDeny() {
    const documentReviewInfo: DocumentReviewModel = {
      requestDetailId: this.engagementDetails.requestDetailId || -1,
      isApprove: false,
      documentType: DocumentsType.AdditionalDocument,
      reasons: [],
      additionalNotes: '',
      customerSurveyId: 0,
      filePath: ''
    };

    this.isApproveReject = true;

    if (this.formInvoiceRejection.controls['invoiceRejectionReason'].value) {
      const selectedReasons =
        this.formInvoiceRejection.controls['invoiceRejectionReason'].value;
      selectedReasons.forEach(element => {
        documentReviewInfo.reasons.push(element);
      });
    }
    documentReviewInfo.additionalNotes =
      this.formInvoiceRejection.controls[
        'additionalNotesRejectionReason'
      ].value;
    if (
      this.engagementPreviewInput.documentType ===
        PreviewDocumentTypes.poeinvoice ||
      this.engagementPreviewInput.documentType ===
        PreviewDocumentTypes.poedocument
    ) {
      this.poeDocHyperLinks.forEach(poeDocs => {
        if (
          poeDocs.poeDocName === this.invoiceDocument ||
          poeDocs.poeDocName === this.invoiceSpecialInvestmentDocument
        ) {
          documentReviewInfo.oFactNominationPOEdocumentsId =
            poeDocs.oFactNominationPOEdocumentsId;
        } else {
          documentReviewInfo.oFactNominationPOEdocumentsId =
            poeDocs.oFactNominationPOEdocumentsId;
        }
      });
      documentReviewInfo.filePath =
        this.engagementPreviewInput.invoiceFile?.poeDocFilePath || '';
    }
    if (this.engagementPreviewInput.documentTypeId === DocumentsType.SOW) {
      documentReviewInfo.documentType = DocumentsType.SOW;
      this.reviewPoeDocuments(documentReviewInfo);
    } else if (
      this.engagementPreviewInput.documentType ===
      PreviewDocumentTypes.poedocument
    ) {
      documentReviewInfo.documentType = DocumentsType.POEDocument;
      this.reviewPoeDocuments(documentReviewInfo);
    } else if (
      this.engagementPreviewInput.documentType ===
      PreviewDocumentTypes.poeinvoice
    ) {
      documentReviewInfo.documentType = DocumentsType.POEInvoice;
      this.reviewPoeDocuments(documentReviewInfo);
    } else if (
      this.engagementPreviewInput.documentType ===
      PreviewDocumentTypes.rfpDescription
    ) {
      documentReviewInfo.documentType =
        DocumentsType.RequestForProposalDescription;
      this.reviewPoeDocuments(documentReviewInfo);
    } else if (
      this.engagementPreviewInput.documentType === PreviewDocumentTypes.rfpAward
    ) {
      documentReviewInfo.documentType =
        DocumentsType.RequestForProposalAwardLetter;
      this.reviewPoeDocuments(documentReviewInfo);
    } else if (
      this.engagementPreviewInput.documentType ===
      PreviewDocumentTypes.customerSurvey
    ) {
      documentReviewInfo.documentType = DocumentsType.CustomerPOESurvey;
      documentReviewInfo.customerSurveyId =
        this.engagementDetails.customerSurveyId;
      this.reviewPoeSurvey(documentReviewInfo);
    } else {
      documentReviewInfo.filePath = this.customerAck[this.index].url || '';
      documentReviewInfo.documentType = DocumentsType.CustomerAcknowledgement;
      this.reviewCustomerAck(documentReviewInfo);
    }
    this.closeDeclineModal();
  }

  showMessage(message: string, isError?: boolean) {
    this.msgsUsageDetails = [];
    this.msgsUsageDetails.push({
      severity: !isError ? 'success' : 'error',
      detail: message
    } as any);
  }

  get DocumentsType(): typeof DocumentsType {
    return DocumentsType;
  }

  onDenyOpen() {
    this.invoiceRejectionModalDisplay = true;
    this.getInvoiceRejectionReasonList();
  }

  getInvoiceRejectionReasonList() {
    const docuemntType = this.engagementPreviewInput.documentType;
    let docuemntTypeToPass: DocumentsType | undefined = undefined;

    if (docuemntType === PreviewDocumentTypes.poeinvoice) {
      docuemntTypeToPass = DocumentsType.POEInvoice;
    } else if (docuemntType === PreviewDocumentTypes.poedocument) {
      docuemntTypeToPass = DocumentsType.POEDocument;
    } else if (docuemntType === PreviewDocumentTypes.customerSurvey) {
      docuemntTypeToPass = DocumentsType.CustomerPOESurvey;
    } else if (this.isCustomerDocumentPreview) {
      docuemntTypeToPass = DocumentsType.CustomerAcknowledgement;
    } else if (docuemntType === PreviewDocumentTypes.rfpDescription) {
      docuemntTypeToPass = DocumentsType.RequestForProposalDescription;
    } else if (docuemntType === PreviewDocumentTypes.rfpAward) {
      docuemntTypeToPass = DocumentsType.RequestForProposalAwardLetter;
    } else if (docuemntType === PreviewDocumentTypes.SOW) {
      docuemntTypeToPass = DocumentsType.SOW;
    }

    this.osmEdit
      .getInvoiceRejectionReasonDropDown(docuemntTypeToPass as DocumentsType)
      .subscribe(RejectionReason => {
        this.invoiceRejectionList = RejectionReason;
      });
  }

  getUploadedPOEDocs_ByEngagementId(engagementId: number) {
    this.osmEdit
      .getUploadedPOEDocs_ByEngagementId(engagementId)
      .subscribe(result => {
        this.poeDocHyperLinks = result;
        if (
          this.engagementPreviewInput.documentType ===
          PreviewDocumentTypes.poeinvoice
        ) {
          const doc = this.poeDocHyperLinks.find(
            x =>
              x.poeDocName === this.invoiceDocument ||
              x.poeDocName === this.invoiceSpecialInvestmentDocument
          );
          this.engagementPreviewInput.invoiceFile = doc;

          if (doc) {
            this.documentStatus = doc.status || '';
            this.documentUploadedDate = doc.uploadDate || new Date();
          }
        } else if (
          this.engagementPreviewInput.documentType ===
          PreviewDocumentTypes.poedocument
        ) {
          this.engagementPreviewInput.invoiceFile = this.poeDocHyperLinks.find(
            x =>
              x.poeDocName !== this.invoiceDocument &&
              x.poeDocName !== this.invoiceSpecialInvestmentDocument
          );
          this.documentStatus =
            this.poeDocHyperLinks.find(
              x =>
                x.poeDocName !== this.invoiceDocument &&
                x.poeDocName !== this.invoiceSpecialInvestmentDocument
            )?.status || '';
          this.documentUploadedDate =
            this.poeDocHyperLinks.find(
              x =>
                x.poeDocName !== this.invoiceDocument &&
                x.poeDocName !== this.invoiceSpecialInvestmentDocument
            )?.uploadDate || new Date();
        } else if (
          this.engagementPreviewInput.documentType ===
          PreviewDocumentTypes.rfpDescription
        ) {
          const doc = this.poeDocHyperLinks.find(
            x => x.poeDocName === this.rfpDescriptionDocument
          );
          this.engagementPreviewInput.invoiceFile = doc;

          if (doc) {
            this.documentStatus = doc.status || '';
            this.documentUploadedDate = doc.uploadDate || new Date();
          }
        } else if (
          this.engagementPreviewInput.documentType ===
          PreviewDocumentTypes.rfpAward
        ) {
          const doc = this.poeDocHyperLinks.find(
            x => x.poeDocName === this.rfpAwardDocument
          );
          this.engagementPreviewInput.invoiceFile = doc;

          if (doc) {
            this.documentStatus = doc.status || '';
            this.documentUploadedDate = doc.uploadDate || new Date();
          }
        } else if (
          this.engagementPreviewInput.documentType === PreviewDocumentTypes.SOW
        ) {
          const doc = this.poeDocHyperLinks.find(
            x => x.poeDocName === this.SOWDocument
          );
          this.engagementPreviewInput.invoiceFile = doc;

          if (doc) {
            this.documentStatus = doc.status || '';
            this.documentUploadedDate = doc.uploadDate || new Date();
          }
        }
        this.resetButton();
        this.previewInvoice(
          this.engagementPreviewInput.invoiceFile as PoeDocHyperLink,
          engagementId
        );
      });
  }

  getCustomerSurveyResponse(id: number) {
    this.osmEdit
      .getPoeSurveyResponse(id.toString(), 'Customer', 'Satisfaction Survey')
      .subscribe(surResult => {
        this.engagementPreviewInput.customerSurveyResponse =
          (surResult && surResult.poeSurveyResponses) ?? [];
        this.downloadSpin = false;
        this.isDocumentPreviewLoading = false;
        this.isSurveyPreview = true;
      });
  }

  getPartnerSurveyResponse(id: number) {
    this.osmEdit
      .getPoeSurveyResponse(id.toString(), 'Partner', 'Findings Survey')
      .subscribe(surResult => {
        this.engagementPreviewInput.customerSurveyResponse =
          (surResult && surResult.poeSurveyResponses) ?? [];
        this.downloadSpin = false;
        this.isDocumentPreviewLoading = false;
        this.isSurveyPreview = true;
      });
  }

  get invoiceDenyButtonEnable(): boolean {
    return (
      this.formInvoiceRejection.controls['invoiceRejectionReason'].value !=
        null &&
      this.formInvoiceRejection.controls['invoiceRejectionReason'].value
        .length > 0
    );
  }

  get hasAdditionalNotesSection(): boolean {
    return (
      this.engagementPreviewInput.documentType ===
        PreviewDocumentTypes.poeinvoice ||
      this.engagementPreviewInput.documentType ===
        PreviewDocumentTypes.poedocument ||
      this.engagementPreviewInput.documentType ===
        PreviewDocumentTypes.rfpDescription ||
      this.engagementPreviewInput.documentType === PreviewDocumentTypes.SOW ||
      this.engagementPreviewInput.documentType === PreviewDocumentTypes.rfpAward
    );
  }

  checkType() {
    let documentType;
    if (this.isAdditionalDocPreview) {
      documentType = this.engagementPreviewInput.additionalDoc?.documentTypeId;
      this.showTypeChangeButtons = true;
    } else if (
      this.isPoeDocumentPreview ||
      this.isPoeInvoicePreview ||
      this.isHistoryDocument ||
      this.isSOWDocumentPreview
    ) {
      documentType =
        this.engagementPreviewInput.invoiceFile?.poeDocName ===
          this.invoiceDocument ||
        this.engagementPreviewInput.documentType ===
          PreviewDocumentTypes.poeinvoice
          ? DocumentsType.POEInvoice
          : this.engagementPreviewInput.invoiceFile?.poeDocName ===
              this.SOWDocument
            ? DocumentsType.SOW
            : DocumentsType.POEDocument;
      if (
        (documentType === DocumentsType.POEInvoice &&
          this.poeDetailsForm.controls['poeDocumentTypeName'].value.type ===
            Constants.poeDocumentType[1].type) ||
        (documentType === DocumentsType.POEDocument &&
          this.poeDetailsForm.controls['poeDocumentTypeName'].value.type ===
            Constants.poeDocumentType[0].type)
      ) {
        this.showTypeChangeButtons = true;
      } else {
        this.showTypeChangeButtons = false;
      }
    }
  }

  setPoeDocumentType() {
    if (this.showTypeChangeButtons) {
      this.showTypeChangeButtons = false;
      this.showApproveDeny = false;
      const documentDetails: DocumentDetailsModel = {
        requestDetailId: this.engagementPreviewInput.engagementId,
        engagementName: this.engagementDetails.engagementName || '',
        engagementType:
          this.engagementDetails.engagementName?.split('+')[0].trim() || '',
        requestedDocumentType:
          this.poeDetailsForm.controls['poeDocumentTypeName'].value.type ===
          Constants.poeDocumentType[0].type
            ? DocumentsType.POEInvoice
            : DocumentsType.POEDocument,
        oFactNominationPOEdocumentsId: 0,
        poeDocumentType: 0,
        filePath: '',
        fileName: '',
        uploadedDate: new Date(),
        status: '',
        isHistoryDocument: false
      };

      if (this.isAdditionalDocPreview) {
        documentDetails.isHistoryDocument = false;
        documentDetails.oFactNominationPOEdocumentsId =
          this.engagementPreviewInput.additionalDoc
            ?.oFactNominationAdditionalDocumentsId || -1;
        documentDetails.poeDocumentType = DocumentsType.AdditionalDocument;
      } else if (this.isPoeDocumentPreview || this.isPoeInvoicePreview) {
        documentDetails.isHistoryDocument = false;
        documentDetails.oFactNominationPOEdocumentsId =
          this.engagementPreviewInput.invoiceFile
            ?.oFactNominationPOEdocumentsId || -1;
        documentDetails.poeDocumentType = DocumentsType.POEDocument;
      } else if (this.isSOWDocumentPreview) {
        documentDetails.isHistoryDocument = false;
        documentDetails.oFactNominationPOEdocumentsId =
          this.engagementPreviewInput.invoiceFile
            ?.oFactNominationPOEdocumentsId || -1;
        documentDetails.poeDocumentType = DocumentsType.SOW;
      } else if (this.isHistoryDocument) {
        documentDetails.isHistoryDocument = this.isHistoryDocument;
        documentDetails.oFactNominationPOEdocumentsId =
          this.engagementPreviewInput.invoiceFile
            ?.oFactNominationPOEdocumentsId || -1;
        documentDetails.fileName =
          this.engagementPreviewInput.invoiceFile?.fileName || '';
        documentDetails.filePath = this.engagementPreviewInput.invoiceFile
          ?.poeDocFilePath
          ? this.engagementPreviewInput.invoiceFile.poeDocFilePath
              .split('?')[0]
              .trim() || ''
          : '';
        documentDetails.status =
          this.engagementPreviewInput.invoiceFile?.status || '';
        documentDetails.uploadedDate =
          this.engagementPreviewInput.invoiceFile?.uploadDate || new Date();
      }

      this.osmEdit.updatePOEDocumentType(documentDetails).subscribe(() => {
        this.closePreview();
        if (this.isAdditionalDocPreview) {
          this.OnDocumentTypeChange.emit(true);
        } else if (
          this.isPoeDocumentPreview ||
          this.isPoeInvoicePreview ||
          this.isHistoryDocument ||
          this.isSOWDocumentPreview
        ) {
          this.OnDocumentTypeChange.emit(false);
        }
      });
    }
  }

  resetButton() {
    this.showTypeChangeButtons = false;
    let documentType;
    if (this.isAdditionalDocPreview) {
      documentType = this.engagementPreviewInput.additionalDoc?.documentTypeId;
    } else if (
      this.isPoeDocumentPreview ||
      this.isPoeInvoicePreview ||
      this.isHistoryDocument
    ) {
      documentType =
        this.engagementPreviewInput.invoiceFile?.poeDocName ===
          this.invoiceDocument ||
        this.engagementPreviewInput.documentTypeId ===
          DocumentsType.POEInvoice ||
        this.engagementPreviewInput.documentType ===
          PreviewDocumentTypes.poeinvoice
          ? DocumentsType.POEInvoice
          : DocumentsType.POEDocument;
    } else if (this.isSOWDocumentPreview) {
      documentType = DocumentsType.SOW;
    } else if (this.isRFPAwardPreview) {
      documentType = DocumentsType.RequestForProposalAwardLetter;
    } else if (this.isRFPDescriptionPreview) {
      documentType = DocumentsType.RequestForProposalDescription;
    }
    if (documentType === DocumentsType.POEInvoice) {
      this.poeDetailsForm.controls['poeDocumentTypeName'].setValue({
        type: Constants.poeDocumentType[0].type
      });
    } else if (documentType === DocumentsType.POEDocument) {
      this.poeDetailsForm.controls['poeDocumentTypeName'].setValue({
        type: Constants.poeDocumentType[1].type
      });
    } else if (documentType === DocumentsType.RequestForProposalAwardLetter) {
      this.poeDetailsForm.controls['poeDocumentTypeName'].setValue({
        type: Constants.poeDocumentType[2].type
      });
    } else if (documentType === DocumentsType.RequestForProposalDescription) {
      this.poeDetailsForm.controls['poeDocumentTypeName'].setValue({
        type: Constants.poeDocumentType[3].type
      });
    } else if (documentType === DocumentsType.SOW) {
      this.poeDetailsForm.controls['poeDocumentTypeName'].setValue({
        type: Constants.poeDocumentType[4].type
      });
    }
  }

  setWorkshopCompletionDate() {
    this.selectedWorkshopCompletionDate = new Date(
      this.selectedWorkshopCompletionDate
    );
    this.dashboardService
      .updateWorkshopDate(
        this.engagementDetails.requestDetailId || -1,
        new Date(this.selectedWorkshopCompletionDate)
      )
      .subscribe(() => {
        this.engagementDetails.workshopCompletionDate =
          this.selectedWorkshopCompletionDate;
      });
  }

  resetWorkshopCompletionDate() {
    this.selectedWorkshopCompletionDate =
      this.engagementDetails.workshopCompletionDate || new Date();
  }
}
